<div class="main">
    <app-ivi-error-screen *ngIf="errorFlag" [errorCode]="errorCode" (retry)="ngOnInit()"
        [page]="pageName"></app-ivi-error-screen>
    <div class="tiles">
        <div class="tile" style="background-image: url('{{ plan.landingPageTileImage }}');"
            *ngFor="let plan of selectedPlans; let i = index; trackBy: trackByIviPlan" (click)="showPackageDetails(plan)"
            [ngClass]="{ 'hide-item': showSecondPackage === 'false' && i === 1 }" role="button" tabindex="0" aria-label="View subscription package details" (keydown.enter)="showPackageDetails(plan)" (keydown.space)="$event.preventDefault(); showPackageDetails(plan)">
            <div class="content-container">
                <div class="description-container">
                    <h1>{{ plan.packageDisplayName | translate }}</h1>
                    <p>{{ plan.description | translate }}</p>
                </div>
                <div class="status-container">
                    <span class="status">
                        {{
                        plan?.isTrialEligible
                        ? (plan.isTrialActive ? ('Trial Active' | translate) : ('Trial Available' | translate))
                        : (plan.isSubscriptionActive ? ('Subscribed' | translate) : ('Subscription Available' |
                        translate))
                        }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
